(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

(function ($, Drupal) {
  $(document).ready(function () {
    $(".accordion-block-full-width").find("a").attr("tabindex", "-1");
    $(".accordion-block-wrap button").click(function () {
      var textLess = $(this).find("a");
      textLess.toggleClass("active");

      if (textLess.hasClass("active")) {
        $(this).parent().find(".accordion-block-full-width").find("a").attr("tabindex", "0");
        textLess.text("Show Less");
      } else {
        $(this).parent().find(".accordion-block-full-width").find("a").attr("tabindex", "-1");
        textLess.text("Show More");
      }
    });
    var max_chars = 5;
    $("#zip").keydown(function (e) {
      if ($(this).val().length >= max_chars) {
        $(this).val($(this).val().substr(0, max_chars));
      }

      var charCode = e.which ? e.which : event.keyCode;

      if (charCode === 9) {
        return true;
      }

      if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
      var evt = "";
      var theEvent = evt || window.event;
      var theVal = theEvent.target.value;
      var key = theEvent.keyCode || theEvent.which;
      key = String.fromCharCode(key);
      if (key.length == 0) return;
      var regex = /^[0-9.,\b]+$/;

      if (!regex.test(key)) {
        if (theEvent.preventDefault) theEvent.preventDefault();
        return false;
      }

      return true;
    });
    $("#zip").keyup(function (e) {
      if ($(this).val().length >= max_chars) {
        $(this).val($(this).val().substr(0, max_chars));
      }

      var charCode = e.which ? e.which : event.keyCode;

      if (charCode === 9) {
        return true;
      }

      if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
      return true;
    });
    $("#weather-search").click(function (e) {
      e.preventDefault();
      var data = "";
      var zip = $("#zip").val();
      var url = "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates?Postal=" + zip + "&f=pjson";
      $.getJSON(url).done(function (data) {
        //console.log(data);
        //console.log(data.candidates.length);
        if (data.candidates.length == "0") {
          //console.log('Zip code not valid.');
          alert("Zip code not valid.");
          return;
        }

        var x = data.candidates["0"].location.x;
        var y = data.candidates["0"].location.y;
        $.getJSON("https://forecast.weather.gov/MapClick.php?&lat=" + y + "&lon=" + x + "&FcstType=json").done(function (weather) {
          //console.log('https://forecast.weather.gov/MapClick.php?&lat=' + y + '&lon=' + x + '&FcstType=json');
          //console.log(weather.time);
          if (weather.success == false) {
            //console.log('Weather not found for this location. Choose another.');
            alert("Weather not found for this location. Choose another.");
            return;
          }

          $("#temp").html(weather.currentobservation.Temp + "&#176;");
          $("#location").html(weather.location.areaDescription);
          var obs = weather.currentobservation.Weather;

          if (obs == "") {
            obs = weather.data.weather["0"];
          }

          var icon = "";

          switch (obs) {
            case "Sunny":
            case "Fair":
            case "Clear":
            case "Fair with Haze":
            case "Clear with Haze":
            case "Mostly Clear":
            case "Fair and Breezy":
            case "Clear and Breezy":
              icon = "fair-clear-fair-clear-haze-fair-breezy-clear-breezy.svg";
              break;

            case "Mostly Cloudy":
            case "Mostly Cloudy with Haze":
            case "Mostly Cloudy and Breezy":
            case "A Few Clouds":
            case "Chance T-storms":
            case "A Few Clouds with Haze":
            case "A Few Clouds and Breezy":
            case "Partly Cloudy":
            case "Partly Cloudy with Haze":
            case "Partly Cloudy and Breezy":
            case "Partly Cloudy then Slight Chance Showers":
            case "Chance T-storms then Chance Showers":
              icon = "few-cloudy-haze-breezy.svg";
              break;

            case "Overcast":
            case "Overcast with Haze":
            case "Overcast and Breezy":
              icon = "overcast-haze-breezy.svg";
              break;

            case "Fog/Mist":
            case "Fog":
            case "Freezing Fog":
            case "Shallow Fog":
            case "Partial Fog":
            case "Patches of Fog":
            case "Patchy Fog then Sunny":
            case "Patchy Fog":
            case "Fog in Vicinity":
            case "Freezing Fog in Vicinity":
            case "Shallow Fog in Vicinity":
            case "Partial Fog in Vicinity":
            case "Patches of Fog in Vicinity":
            case "Showers in Vicinity Fog":
            case "Heavy Freezing Fog":
            case "Light Freezing Fog":
              icon = "fog-mist.svg";
              break;

            case "Smoke":
              icon = "smoke.svg";
              break;

            case "Freezing Rain":
            case "Freezing Drizzle":
            case "Light Freezing Rain":
            case "Light Freezing Drizzle":
            case "Heavy Freezing Rain":
            case "Heavy Freezing Drizzle":
            case "Freezing Rain in Vicinity":
            case "Freezing Drizzle in Vicinity":
            case "Ice Pellets":
            case "Light Ice Pellets":
            case "Heavy Ice Pellets":
            case "Ice Pellets in Vicinity":
            case "Showers Ice Pellets":
            case "Thunderstorm Ice Pellets":
            case "Ice Crystals":
            case "Hail":
            case "Small Hail/Snow Pellets":
            case "Light Small Hail/Snow Pellets":
            case "Heavy small Hail/Snow Pellets":
            case "Showers Hail":
            case "Hail Showers":
            case "Freezing Rain Snow":
            case "Light Freezing Rain Snow":
            case "Heavy Freezing Rain Snow":
            case "Freezing Drizzle Snow":
            case "Light Freezing Drizzle Snow":
            case "Heavy Freezing Drizzle Snow":
            case "Snow Freezing Rain":
            case "Light Snow Freezing Rain":
            case "Heavy Snow Freezing Rain":
            case "Snow Freezing Drizzle":
            case "Light Snow Freezing Drizzle":
            case "Heavy Snow Freezing Drizzle":
            case "Rain Ice Pellets":
            case "Light Rain Ice Pellets":
            case "Heavy Rain Ice Pellets":
            case "Drizzle Ice Pellets":
            case "Light Drizzle Ice Pellets":
            case "Heavy Drizzle Ice Pellets":
            case "Ice Pellets Rain":
            case "Light Ice Pellets Rain":
            case "Heavy Ice Pellets Rain":
            case "Ice Pellets Drizzle":
            case "Light Ice Pellets Drizzle":
            case "Heavy Ice Pellets Drizzle":
            case "Rain Snow":
            case "Light Rain Snow":
            case "Heavy Rain Snow":
            case "Snow Rain":
            case "Light Snow Rain":
            case "Heavy Snow Rain":
            case "Drizzle Snow":
            case "Light Drizzle Snow":
            case "Snow Drizzle":
            case "Light Snow Drizzle":
            case "Heavy Drizzle Snow":
              icon = "freezing-rain-ice.svg";
              break;

            case "Rain Showers":
            case "Light Rain Showers":
            case "Light Rain and Breezy":
            case "Heavy Rain Showers":
            case "Rain Showers in Vicinity":
            case "Light Showers Rain":
            case "Heavy Showers Rain":
            case "Showers Rain":
            case "Showers Rain in Vicinity":
            case "Rain Showers Fog/Mist":
            case "Light Rain Showers Fog/Mist":
            case "Heavy Rain Showers Fog/Mist":
            case "Rain Showers in Vicinity Fog/Mist":
            case "Light Showers Rain Fog/Mist":
            case "Heavy Showers Rain Fog/Mist":
            case "Showers Rain Fog/Mist":
            case "Showers Rain in Vicinity Fog/Mist":
              icon = "rain-showers.svg";
              break;

            case "Thunderstorm":
            case "Thunderstorm Rain":
            case "Light Thunderstorm Rain":
            case "Heavy Thunderstorm Rain":
            case "Light Thunderstorm Rain Fog/Mist":
            case "Heavy Thunderstorm Rain Fog and Windy":
            case "Heavy Thunderstorm Rain Fog/Mist":
            case "Light Thunderstorm Rain Haze":
            case "Heavy Thunderstorm Rain Haze":
            case "Light Thunderstorm Rain Fog":
            case "Heavy Thunderstorm Rain Fog":
            case "Thunderstorm Light Rain":
            case "Thunderstorm Heavy Rain":
            case "Thunderstorm Rain Fog/Mist":
            case "Thunderstorm Light Rain Fog/Mist":
            case "Thunderstorm Heavy Rain Fog/Mist":
            case "Thunderstorm in Vicinity Fog/Mist":
            case "Thunderstorm Showers in Vicinity":
            case "Thunderstorm Haze in Vicinity":
            case "Thunderstorm Light Rain Haze":
            case "Thunderstorm Heavy Rain Haze":
            case "Thunderstorm Fog":
            case "Thunderstorm Light Rain Fog":
            case "Thunderstorm Heavy Rain Fog":
            case "Thunderstorm Hail":
            case "Light Thunderstorm Rain Hail":
            case "Heavy Thunderstorm Rain Hail":
            case "Light Thunderstorm Rain Hail Fog/Mist":
            case "Heavy Thunderstorm Rain Hail Fog/Hail":
            case "Thunderstorm Showers in Vicinity Hail":
            case "Light Thunderstorm Rain Hail Haze":
            case "Heavy Thunderstorm Rain Hail Haze":
            case "Light Thunderstorm Rain Hail Fog":
            case "Heavy Thunderstorm Rain Hail Fog":
            case "Thunderstorm Light Rain Hail":
            case "Thunderstorm Heavy Rain Hail":
            case "Thunderstorm Rain Hail Fog/Mist":
            case "Thunderstorm Light Rain Hail Fog/Mist":
            case "Thunderstorm Heavy Rain Hail Fog/Mist":
            case "Thunderstorm in Vicinity Hail":
            case "Thunderstorm in Vicinity Hail Haze":
            case "Thunderstorm Haze in Vicinity Hail":
            case "Thunderstorm Light Rain Hail Haze":
            case "Thunderstorm Heavy Rain Hail Haze":
            case "Thunderstorm Hail Fog":
            case "Thunderstorm Light Rain Hail Fog":
            case "Thunderstorm Heavy Rain Hail Fog":
            case "Thunderstorm Small Hail/Snow Pellets":
            case "Thunderstorm Rain Small Hail/Snow Pellets":
            case "Light Thunderstorm Rain Small Hail/Snow Pellets":
            case "Heavy Thunderstorm Rain Small Hail/Snow Pellets":
              icon = "Tstorm.svg";
              break;

            case "Snow":
            case "Light Snow":
            case "Heavy Snow":
            case "Snow Showers":
            case "Light Snow Showers":
            case "Heavy Snow Showers":
            case "Showers Snow":
            case "Light Showers Snow":
            case "Heavy Showers Snow":
            case "Snow Fog/Mist":
            case "Light Snow Fog/Mist":
            case "Heavy Snow Fog/Mist":
            case "Snow Showers Fog/Mist":
            case "Light Snow Showers Fog/Mist":
            case "Heavy Snow Showers Fog/Mist":
            case "Showers Snow Fog/Mist":
            case "Light Showers Snow Fog/Mist":
            case "Heavy Showers Snow Fog/Mist":
            case "Snow Fog":
            case "Light Snow Fog":
            case "Heavy Snow Fog":
            case "Snow Showers Fog":
            case "Light Snow Showers Fog":
            case "Heavy Snow Showers Fog":
            case "Showers Snow Fog":
            case "Light Showers Snow Fog":
            case "Heavy Showers Snow Fog":
            case "Showers in Vicinity Snow":
            case "Snow Showers in Vicinity":
            case "Snow Showers in Vicinity Fog/Mist":
            case "Snow Showers in Vicinity Fog":
            case "Low Drifting Snow":
            case "Blowing Snow":
            case "Snow Low Drifting Snow":
            case "Snow Blowing Snow":
            case "Light Snow Low Drifting Snow":
            case "Light Snow Blowing Snow":
            case "Light Snow Blowing Snow Fog/Mist":
            case "Heavy Snow Low Drifting Snow":
            case "Heavy Snow Blowing Snow":
            case "Thunderstorm Snow":
            case "Light Thunderstorm Snow":
            case "Heavy Thunderstorm Snow":
            case "Snow Grains":
            case "Light Snow Grains":
            case "Heavy Snow Grains":
            case "Heavy Blowing Snow":
            case "Blowing Snow in Vicinity":
              icon = "snow.svg";
              break;

            case "Windy":
            case "Breezy":
            case "Fair and Windy":
            case "A Few Clouds and Windy":
            case "Partly Cloudy and Windy":
            case "Mostly Cloudy and Windy":
            case "Overcast and Windy":
              icon = "windy-breezy.svg";
              break;

            case "Showers in Vicinity":
            case "Showers in Vicinity Fog":
            case "Showers in Vicinity Fog/Mist":
            case "Showers in Vicinity Haze":
              icon = "rain-showers.svg";
              break;

            case "Freezing Rain Rain":
            case "Light Freezing Rain Rain":
            case "Heavy Freezing Rain Rain":
            case "Rain Freezing Rain":
            case "Light Rain Freezing Rain":
            case "Heavy Rain Freezing Rain":
            case "Freezing Drizzle Rain":
            case "Light Freezing Drizzle Rain":
            case "Heavy Freezing Drizzle Rain":
            case "Rain Freezing Drizzle":
            case "Light Rain Freezing Drizzle":
            case "Heavy Rain Freezing Drizzle":
              icon = "freezing-rain-ice.svg";
              break;

            case "Thunderstorm in Vicinity":
            case "Thunderstorm in Vicinity Fog":
            case "Thunderstorm in Vicinity Haze":
              icon = "Tstorm.svg";
              break;

            case "Light Rain":
            case "Drizzle":
            case "Light Drizzle":
            case "Heavy Drizzle":
            case "Light Rain Fog/Mist":
            case "Drizzle Fog/Mist":
            case "Light Drizzle Fog/Mist":
            case "Heavy Drizzle Fog/Mist":
            case "Light Rain Fog":
            case "Drizzle Fog":
            case "Light Drizzle Fog":
            case "Heavy Drizzle Fog":
            case "Rain":
            case "Heavy Rain":
            case "Rain Fog/Mist":
            case "Heavy Rain Fog/Mist":
            case "Rain Fog":
            case "Heavy Rain Fog":
              icon = "light-rain-drizzle.svg";
              break;

            case "Funnel Cloud":
            case "Funnel Cloud in Vicinity":
            case "Tornado/Water Spout":
              icon = "funnel-cloud.svg";
              break;

            case "Dust":
            case "Low Drifting Dust":
            case "Blowing Dust":
            case "Sand":
            case "Blowing Sand":
            case "Low Drifting Sand":
            case "Dust/Sand Whirls":
            case "Dust/Sand Whirls in Vicinity":
            case "Dust Storm":
            case "Heavy Dust Storm":
            case "Dust Storm in Vicinity":
            case "Sand Storm":
            case "Heavy Sand Storm":
            case "Sand Storm in Vicinity":
              icon = "dust.svg";
              break;

            case "Haze":
              icon = "haze.svg";
              break;
          }

          $("#icon").html('<img src="/themes/usda/js/farmers/weather-icons/' + icon + '"/>');
          $("#condition").html(obs);
          var lo = weather.data.temperature["1"] + "&#176;";
          var hi = weather.data.temperature["0"] + "&#176;"; //console.log('hi: ' + hi);
          //console.log('lo: ' + lo);

          var tempLabelone = weather.time.tempLabel["0"]; //var tempLabeltwo = weather.time.tempLabel['1'];

          if (tempLabelone === "High") {
            $("#hiandlow").html(hi + "/" + lo + " high/low");
          } else {
            $("#hiandlow").html(lo + "/" + hi + " high/low");
          }

          $("#time").html(weather.currentobservation.Date);
          var windD = parseInt(weather.currentobservation.Windd);
          var direction = "";
          var windString = "";

          if (windD > 340 && windD < 29) {
            direction = "N";
          } else if (windD > 30 && windD < 69) {
            direction = "NE";
          } else if (windD > 70 && windD < 129) {
            direction = "E";
          } else if (windD > 130 && windD < 159) {
            direction = "SE";
          } else if (windD > 160 && windD < 200) {
            direction = "S";
          } else if (windD > 201 && windD < 240) {
            direction = "SW";
          } else if (windD > 241 && windD < 290) {
            direction = "W";
          } else if (windD > 291 && windD < 339) {
            direction = "NW";
          } //console.log(windD);


          var windS = parseInt(weather.currentobservation.Winds);

          if (windS <= 1) {
            windString = "Calm";
          } else {
            windString = direction + " " + windS + " mph winds";
          }

          $("#wind-speed").html(windString);
          $("#new-weather").fadeIn().css("display", "table");
        });
      });
    });
    $("#zip").keypress(function (e) {
      if (e.which == 13) {
        // Enter key pressed
        $("#weather-search").click(); // Trigger search button click event
      }
    });
    $("#change").click(function () {
      $("#new-weather").fadeOut(200);
      $("#zip").focus().val("");
    });
  });
  Drupal.behaviors.usda = {
    attach: function attach(context, settings) {
      // IMPORTANT: Do not put any functions in here as the usda behaviors are not working at the moment.
      // Place them in the $(document).ready(function()) at the top of the script instead.
      // Mobile video carousel text and controls
      // *** DOESN'T APPEAR TO BE USED RIGHT NOW *** - mbc
      $(document).ready(function () {
        var slickActive = $("#video-carousel .slick-dots li.slick-active button").attr("aria-label");
        $("#video-carousel").append('<div id="mobile-video-slick"><button class="mobile-vid-prev" aria-label="Previous" type="button" tabindex="0" style="">Previous</button><div class="slide-count">' + slickActive + ' </div><button class="mobile-vid-next" aria-label="Next" type="button" tabindex="0" style="">Next</button></div>');
        $("#video-carousel #mobile-video-slick .mobile-vid-prev").click(function () {
          $("#video-carousel .slick-prev").click();
        });
        $("#video-carousel #mobile-video-slick .mobile-vid-next").click(function () {
          $("#video-carousel .slick-next").click();
        });
        $("#video-carousel").on("afterChange", function (event, slick, direction) {
          var slickActive = $("#video-carousel .slick-dots li.slick-active button").attr("aria-label");
          $("#video-carousel .slide-count").text(slickActive);
        });
      });
    }
  };
  Drupal.behaviors.farmersLearnMore = {
    attach: function attach(context, settings) {
      // Sets playbook link's tabindex, done using JS since content is in Drupal
      $(".learn-more-farmers__content").children().find("a").attr("tabindex", -1);
      var learnMoreElement = $(".learn-more-farmers .learn-more-farmers__trigger");

      if (learnMoreElement.length > 0) {
        var parentLearnMore = $(learnMoreElement.parents(".learn-more-farmers")[0]);
        var dropdown = parentLearnMore.find(".learn-more-farmers__dropdown");

        var farmersLearnMoreStyles = function farmersLearnMoreStyles(dropdown, hidden) {
          if (hidden === true) {
            dropdown.css("height", "0"); // Adding 508 controls and tab indexes

            dropdown.children(".learn-more-farmers__content").attr("aria-hidden", true);
            learnMoreElement.attr("aria-expanded", false);
            $(".learn-more-farmers__content").children().find("a").attr("tabindex", -1);
          } else {
            dropdown.css("height", dropdown.children(".learn-more-farmers__content").outerHeight(true) + "px"); // Adding 508 controls and tab indexes

            dropdown.children(".learn-more-farmers__content").attr("aria-hidden", false);
            learnMoreElement.attr("aria-expanded", true);
            $(".learn-more-farmers__content").children().find("a").attr("tabindex", 0);
          }
        };

        var farmersLearnMore = function farmersLearnMore(target) {
          if (parentLearnMore.hasClass("active")) {
            parentLearnMore.removeClass("active");
            farmersLearnMoreStyles(dropdown, true);
          } else {
            parentLearnMore.addClass("active");
            farmersLearnMoreStyles(dropdown, false);
          }
        };

        $(window).resize(function () {
          if (parentLearnMore.hasClass("active")) {
            farmersLearnMoreStyles(dropdown, false);
          }
        });
        learnMoreElement.once("farmersLearnMore").on("click", function (event) {
          farmersLearnMore(event.currentTarget);
        });
      }
    }
  };
  Drupal.behaviors.farmersAccordion = {
    attach: function attach(context, settings) {
      $(".accordion-grid").each(function () {
        $(this).find(".accordion").matchHeight({
          byRow: true
        });
      });
      $(".accordion-bellows").on("click", function (event) {
        event.stopPropagation();
      }); // helper function that handles the styling, aria-labels, and tabindexes

      var accordionStyle = function accordionStyle(clickedAccordion, accordionContent, active) {
        // grid sizing
        var parentAccordionGrid = $($(accordionContent).parents(".accordion-grid")[0]);
        var parentAccordionRow = parentAccordionGrid.find(".accordion-row");
        var accordionLinks = clickedAccordion.find("a");
        var activeWindowOffsetLeft = clickedAccordion.offset().left - parentAccordionRow.offset().left;
        if (window.innerWidth === 768) activeWindowOffsetLeft = activeWindowOffsetLeft - 15;

        if (active === true) {
          // set tabindex of all links inside the accordion to 0
          for (var i = 0; i < accordionLinks.length; i++) {
            accordionLinks[i].setAttribute("tabindex", "0");
          }

          accordionContent.attr("aria-hidden", false);
          accordionContent.css("display", "block");
          accordionContent.css("top", clickedAccordion.outerHeight(false) + "px");

          if (clickedAccordion.parent().width() >= clickedAccordion.outerWidth()) {
            accordionContent.css("width", clickedAccordion.parent().width() + "px");
          } else {
            accordionContent.css("width", parentAccordionGrid.innerWidth() + "px");
          }

          accordionContent.css("left", "-" + activeWindowOffsetLeft + "px");
          accordionContent.css("height", "0");
          parentAccordionGrid.find(".accordion").css("margin-bottom", "");
          accordionContent.css("height", $(accordionContent).children().outerHeight(true) + 10 + "px");
          clickedAccordion.css("margin-bottom", $(accordionContent).children().outerHeight(true) + 30 + "px");
        } else {
          for (var _i = 0; _i < accordionLinks.length; _i++) {
            accordionLinks[_i].setAttribute("tabindex", "-1");
          }

          accordionContent.attr("aria-hidden", true);
          accordionContent.css("display", "none");
          parentAccordionGrid.find(".accordion").css("margin-bottom", "");
          accordionContent.css("height", "0");
        }
      };

      $(".accordion").on("click keydown", function (e) {
        if (e.keyCode !== 13 && e.type === "keydown") return;
        var accordion = $(this);
        var accordionContent = accordion.find(".accordion-bellows"); // if clicked accordion is already open, remove the active class, close it

        if (accordion.hasClass("active")) {
          $(".accordion").removeClass("active");
          $(".accordion-bellows").removeClass("active");
          accordionStyle(accordion, accordionContent, false);
        } else {
          // removing active class from all accordions to ensure there's never more than one active
          $(".accordion").removeClass("active");
          $(".accordion-bellows").removeClass("active");
          accordion.addClass("active");
          accordionContent.addClass("active");
          accordionStyle(accordion, accordionContent, true);
        } // hide all accordion details that aren't the currently opened one


        $(".accordion-bellows").not(accordionContent).css("display", "none");
      });
    }
  }; // 508 Compliance Navigation

  document.body.onkeydown = function (e) {
    e = e || window.event; // Normalize the event for IE

    var target = e.srcElement || e.target; // Get the element that event was triggered on

    var tagName = target.tagName; // get the tag name of the element

    if (tagName === "BODY") {
      return true;
    }

    if (tagName !== "TEXTAREA" && tagName !== "INPUT") {
      return !(e.keyCode === 32);
    }
  };

  document.body.onkeyup = function (e) {
    e = e || window.event; // Normalize the event for IE

    var target = e.srcElement || e.target; // Get the element that event was triggered on

    if (e.keyCode === 32) {
      if (target.tagName.toLowerCase() === "a" || target.tagName.toLowerCase() === "button" || target.classList.contains("accordion") || target.classList.contains("card") || target.classList.contains("learn-more-farmers__trigger") || target.classList.contains("close")) {
        e.preventDefault();
        target.click();
      }
    }
  }; // needed to add this for the MFP form privacy act disclaimer to work correctly


  var learnMoreElement = $(".mfp-learn-more-farmers .mfp-learn-more-farmers__trigger");

  if (learnMoreElement.length > 0) {
    var parentLearnMore = $(learnMoreElement.parents(".mfp-learn-more-farmers")[0]);
    var dropdown = parentLearnMore.find(".mfp-learn-more-farmers__dropdown");

    var farmersLearnMoreStyles = function farmersLearnMoreStyles(dropdown, hidden) {
      if (hidden === true) {
        dropdown.css("height", "0"); // Adding 508 controls and tab indexes

        dropdown.children(".mfp-learn-more-farmers__content").attr("aria-hidden", true);
        learnMoreElement.attr("aria-expanded", false);
        $(".mfp-learn-more-farmers__content").children().find("a").attr("tabindex", -1);
      } else {
        dropdown.css("height", dropdown.children(".mfp-learn-more-farmers__content").outerHeight(true) + "px"); // Adding 508 controls and tab indexes

        dropdown.children(".mfp-learn-more-farmers__content").attr("aria-hidden", false);
        learnMoreElement.attr("aria-expanded", true);
        $(".mfp-learn-more-farmers__content").children().find("a").attr("tabindex", 0);
      }
    };

    var farmersLearnMore = function farmersLearnMore(target) {
      if (parentLearnMore.hasClass("active")) {
        parentLearnMore.removeClass("active");
        farmersLearnMoreStyles(dropdown, true);
      } else {
        parentLearnMore.addClass("active");
        farmersLearnMoreStyles(dropdown, false);
      }
    };

    $(window).resize(function () {
      if (parentLearnMore.hasClass("active")) {
        farmersLearnMoreStyles(dropdown, false);
      }
    });
    learnMoreElement.on("click", function (event) {
      farmersLearnMore(event.currentTarget);
    });
  }

  var stringTrimmer = function stringTrimmer(node) {
    var string = node.text();
    var newString = string.split("_").join("");
    node.text(newString);
  };

  if ($("#block-farmers-ccc-910-webform").length) {
    $("#edit-actions").prepend('<hr style="border-top: dotted 1px;">'); // setting the styling for the button and apply text that should only appear in step 1

    setInterval(function () {
      if ($("li.progress-step")[0].classList.contains("is-active")) {
        $("#edit-actions-wizard-next").css("float", "none");
        $(".apply-text").removeClass("hidden");
      } else {
        $("#edit-actions-wizard-next").css("float", "right");
        $(".apply-text").addClass("hidden");
        $(".step-1-header").addClass("hidden");
      } // all of this to disable the next button if nothing is selected


      if ($("li.progress-step")[1].classList.contains("is-active")) {
        if ($("#edit-crops-checks-corn").prop("checked") || $("#edit-crops-checks-cotton").prop("checked") || $("#edit-crops-checks-sorghum").prop("checked") || $("#edit-crops-checks-soybeans").prop("checked") || $("#edit-crops-checks-wheat").prop("checked") || $("#edit-livestock-related-checks-dairy").prop("checked") || $("#edit-livestock-related-checks-hogs").prop("checked") || $("#edit-crops-checks-shelled-almonds").prop("checked") || $("#edit-crops-checks-fresh-sweet-cherries").prop("checked")) {
          $("#edit-actions-wizard-next").prop("disabled", false);
        } else if (!$("#edit-crops-checks-corn").prop("checked") || !$("#edit-crops-checks-cotton").prop("checked") || !$("#edit-crops-checks-sorghum").prop("checked") || !$("#edit-crops-checks-soybeans").prop("checked") || !$("#edit-crops-checks-wheat").prop("checked") || !$("#edit-livestock-related-checks-dairy").prop("checked") || !$("#edit-livestock-related-checks-hogs").prop("checked") || !$("#edit-crops-checks-shelled-almonds").prop("checked") || !$("#edit-crops-checks-fresh-sweet-cherries").prop("checked")) {
          $("#edit-actions-wizard-next").prop("disabled", true);
        }

        $(".step-2-header").removeClass("hidden");
      } else {
        $(".step-2-header").addClass("hidden");
      }

      if ($('li[data-webform-page="production_information"]')[0].classList.contains("is-active")) {
        $(".step-3-header").removeClass("hidden");
      } else {
        $(".step-3-header").addClass("hidden");
      }
    }, 200);

    if ($('li[data-webform-page="production_information"]')[0].classList.contains("is-active") && $(".js-form-item-cwt-dairy").length) {
      $('label[for="edit-cwt-dairy"]').append('<a class="tooltip-link" data-tooltip="hundredweight" tabindex="0">i</a>');
    } // if we're on the confirmation step of the webform


    if ($(".webform-confirmation").length) {
      $("#initial-step-stepper").addClass("hidden");
      $("#final-step-stepper").removeClass("hidden");
      $(".step-4-header").removeClass("hidden"); // remove the underscores

      stringTrimmer($(".corn-bushels"));
      stringTrimmer($(".cotton-bushels"));
      stringTrimmer($(".sorghum-bushels"));
      stringTrimmer($(".soybean-bushels"));
      stringTrimmer($(".wheat-bushels"));
      stringTrimmer($(".shelled-almonds-pounds"));
      stringTrimmer($(".fresh-sweet-cherries-pounds"));
      stringTrimmer($(".dairy-cwt"));
      stringTrimmer($(".hog-head")); // if these fields dont contain a number, hide them

      if (!$(".corn-bushels").text().match(/\d/)) {
        $(".corn-bushels").addClass("hidden");
      }

      if (!$(".cotton-bushels").text().match(/\d/)) {
        $(".cotton-bushels").addClass("hidden");
      }

      if (!$(".sorghum-bushels").text().match(/\d/)) {
        $(".sorghum-bushels").addClass("hidden");
      }

      if (!$(".soybean-bushels").text().match(/\d/)) {
        $(".soybean-bushels").addClass("hidden");
      }

      if (!$(".wheat-bushels").text().match(/\d/)) {
        $(".wheat-bushels").addClass("hidden");
      }

      if (!$(".shelled-almonds-pounds").text().match(/\d/)) {
        $(".shelled-almonds-pounds").addClass("hidden");
      }

      if (!$(".fresh-sweet-cherries-pounds").text().match(/\d/)) {
        $(".fresh-sweet-cherries-pounds").addClass("hidden");
      }

      if (!$(".dairy-cwt").text().match(/\d/)) {
        $(".dairy-cwt").addClass("hidden");
      }

      if (!$(".hog-head").text().match(/\d/)) {
        $(".hog-head").addClass("hidden");
      }
    } else {
      $(".step-4-header").addClass("hidden");
    } //MFP form auto-filling fields


    $('label[for="edit-same-as-producer-name"]').on("click", function () {
      if ($(this).hasClass("checked")) {
        $(this).removeClass("checked");
        $("#edit-first-name-contact").val("").focus();
        $("#edit-middle-name-contact").val("").focus();
        $("#edit-last-name-contact").val("").focus();
      } else {
        $(this).addClass("checked");
        $("#edit-first-name-contact").val($("#edit-first-name").val()).focus();
        $("#edit-middle-name-contact").val($("#edit-middle-name").val()).focus();
        $("#edit-last-name-contact").val($("#edit-last-name").val()).focus();
      }
    });
    $("#edit-who-is-this-an-entity").on("click", function () {
      if ($("#edit-middle-name").val() !== "" || $("#edit-last-name").val() !== "") {
        $("#edit-middle-name").val("");
        $("#edit-last-name").val("");
      }
    });
    $(".js-form-type-checkbox").on("click", function () {
      if ($(this).prop("checked")) {
        $(this).prop("checked", false);
      } else {
        $(this).prop("checked", true);
      }
    });
  }

  $(document).ready(function () {
    $("*[id*=slick-slide-control]").each(function () {
      $(this).attr("tabindex", "0");
    });
    $(".blog-hero-carousel-content").find("button").attr("tabindex", "-1");
    $(".carousel").slick({
      adaptiveWidth: true,
      adaptiveHeight: true,
      accessibility: true
    });
    $(".card-carousel").slick({
      adaptiveWidth: true,
      adaptiveHeight: true,
      accessibility: true
    });
    $(".blog-carousel").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      accessibility: true,
      infinite: true,
      responsive: [{
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 559,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });
    var blogStoryCarousel = document.querySelectorAll("#blog-stories-carousel");
    blogStoryCarousel.forEach(function (carousel) {
      var slides = carousel.querySelectorAll(".blog-stories-item");
      var slideTrackHeight = carousel.querySelector(".slick-track").getBoundingClientRect().height;
      slides.forEach(function (slide) {
        slide.style.height = slideTrackHeight + "px";
      });
    }); // Removing keyboard focus for images because the 'Read More' buttons
    // use the same link.

    $(".blog-carousel .slick-image-link").each(function () {
      $(this).removeAttr("tabindex");
      $(this).attr("tabindex", "-1");
    });
    $(".image-carousel").slick({
      infinite: true,
      accessibility: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
    $(".view-blog-category-carousel .view-content, .view-multi-select-blog-category-carousel .view-content").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      accessibility: true,
      variableWidth: true,
      infinite: false,
      responsive: [{
        breakpoint: 559,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }]
    });
    $("#blog-hero-carousel .field__items").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      accessibility: true,
      infinite: true,
      responsive: [{
        breakpoint: 559,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        }
      }, {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        }
      }]
    });
    $("#video-carousel").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      accessibility: true,
      variableWidth: true,
      centerMode: true,
      centerPadding: "25px",
      infinite: true,
      responsive: [{
        breakpoint: 559,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          variableWidth: false
        }
      }, {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          variableWidth: false
        }
      }]
    });

    function to_position(divid) {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var topPosition = document.querySelector(divid).getBoundingClientRect().top + scrollTop;
      $("html, body").animate({
        scrollTop: topPosition - 50
      }, "slow");
    }

    $(".anchor-link-target").click(function (event) {
      event.preventDefault();
      event.stopPropagation();
      var anchor = $(this).data("anchor");

      if ($(this).data("accordion") === "") {
        $(".accordion.active").click();
        setTimeout(function () {
          to_position(anchor);
          $(anchor).click();
        }, 400);
      } else {
        to_position(anchor);
      }
    });
    var isMobile = false; //initiate as false
    // device detection

    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
      isMobile = true;
    }

    var is_iPad = navigator.userAgent.match(/iPad/i) != null; // ============================================
    // adding aria-labels to sevice center locator

    $(".simpler-select.form-select.simpler-select-root").eq(0).attr({
      label: "Select a State",
      "aria-label": "Select a State"
    });
    $(".simpler-select.form-select.simpler-select-root").eq(0).change(function () {
      $(".simpler-select.form-select.simpler-select-root").eq(1).attr({
        label: "Select a County",
        "aria-label": "Select a County"
      });
    });

    if (is_iPad && Math.abs(window.orientation) === 90 || !isMobile) {
      $(".usa-nav-submenu > li > a").click(function (e) {
        if ($(this).parent().find(".usa-nav-submenu-submenu").length > 0) {
          e.preventDefault();
          e.stopPropagation();
          $(".usa-nav-submenu-submenu").hide();
          $(".submenu-item-active").removeClass("submenu-item-active");
          $(this).parent().find(".usa-nav-submenu-submenu").toggle();
          $(this).toggleClass("submenu-item-active");
        }
      });
      $(".usa-accordion-button.usa-nav-link").click(function () {
        $(".submenu-item-active").removeClass("submenu-item-active");
        $(".usa-nav-submenu-submenu:visible").hide();
      });
    }
  });
  adjustHomepageLogoForAlert(); // site alert

  function adjustHomepageLogoForAlert() {
    if ($("div").hasClass("site-alert") && $("div").hasClass("farmers-call-to-action")) {
      var siteAlertHeight = $(".site-alert").height();
      $(".farmers-call-to-action").css({
        position: "relative",
        top: siteAlertHeight + "px"
      });
    }
  }

  $(document).ready(function () {
    setMobileAccordions();
    processPrintFooter();
    addTabIndexToElements(document.querySelectorAll(".category-slide"));
    convertDesignSystemExternalLinks(document.querySelectorAll(".resource-card .link a"));
    convertDesignSystemExternalLinks(document.querySelectorAll(".national-programs-deadline-home-block .text-link"));
    convertDesignSystemExternalLinks(document.querySelectorAll(".national-programs-deadline-page-ongoing .text-link"));
    convertDesignSystemExternalLinks(document.querySelectorAll(".national-programs-deadline-page-past .text-link"));
  });

  window.onresize = function (event) {
    setMobileAccordions();
  };

  function setMobileAccordions() {
    var mobileAccordions = document.querySelectorAll(".mobile-accordion");
    mobileAccordions.forEach(function (accordion) {
      var title = accordion.querySelector(".Accordion-trigger");
      var style = window.getComputedStyle(title);
      var hidden = style.pointerEvents === "auto" ? true : false;
      var accordionContent = accordion.querySelectorAll(".Accordion-panel");
      accordionContent.forEach(function (content) {
        if (hidden) {
          content.setAttribute("hidden", "");
        } else {
          content.removeAttribute("hidden");
        }
      });
    });
  }

  function convertDesignSystemExternalLinks(links) {
    if (links) {
      links.forEach(function (link) {
        var external = link.querySelector("svg.ext");

        if (external) {
          link.classList.remove("text-link");
          link.classList.add("external-link");
          external.style.display = "none";
        }
      });
    }
  }

  function processPrintFooter() {
    var print_footer = document.querySelector("#print-footer-container") ? document.querySelector("#print-footer-container").cloneNode(true) : "";

    if (print_footer) {
      var today = new Date();
      var dd = String(today.getDate());
      var mm = String(today.getMonth() + 1);
      var yy = today.getFullYear().toString().substr(-2);
      today = mm + "/" + dd + "/" + yy;
      document.querySelector(".print-footer-date").innerHTML = today;
    }
  }

  function addTabIndexToElements(elements) {
    // this is used when we can't modify a twig template (such as core theme files)
    if (elements) {
      elements.forEach(function (element) {
        element.tabIndex = "0";
      });
    }
  }
})(jQuery, Drupal);

},{}]},{},[1]);
